export default __webpack_public_path__ + "d6f2939e2314a1a36dcf8cdc922311df.png";